import React, { useEffect } from 'react'
import './style.css'
import { Col, Container, Row } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import { APIINTEGRATION } from '../../../assets/images'
import SEO from '../../../components/seo/SEO'
import MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer'

const CertificationsAndPartnerPrograms = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <>
            <SEO
              title="Certifications & Partner Programs"
              description="Learn about Triumphal's certifications and technology partner programs that back the quality and credibility of our enterprise solutions."
              path="/trust/certifications-and-partner-programs"
              keywords="certifications, partner programs, technology partnerships"
            />
            <Navigation />
            <Banner title="Certifications & Partner Programs" bg={APIINTEGRATION} />

            <section className='api_intergration_section'>
                <Container className='mt-75 mb-75'>
                    <div>
                        <Row>
                            <Col lg={11}>
                                <div className='api_intergration_section_title'>
                                    <h3>
                                       Recognized frameworks and a deep technology ecosystem—so your solutions integrate, scale, and pass enterprise review.
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </div>


                       <div className='mt-75 api_intergration_cards'>
                <MultiListCard  />
            </div>
                </Container>
            </section>

            <Footer />
        </>
    )
}

export default CertificationsAndPartnerPrograms